import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledTreatmentCategory = styled('div')`
  display: flex;
  word-break: break-word;
`;

export const StyledRadioOptionContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    cursor: pointer;
    column-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledTreatmentCategoryImage = styled('img')(
  ({ theme }) => css`
    width: ${theme.spacing('5XL')};
    height: ${theme.spacing('5XL')};
  `
);
